import {Component, Input, OnInit} from '@angular/core';
import {PolicyService} from '../../../policy/services/policy.service';
import {PolicyQuery} from '../../../policy/state/policy.query';

declare var jQuery: any;
@Component({
    selector: 'app-cancel-modal',
    templateUrl: './cancel-modal.component.html',
    styleUrls: ['./cancel-modal.component.scss'],
    standalone: false
})
export class CancelModalComponent implements OnInit {
  @Input() item: any;
  policy:any;
  constructor(
    private policyQuery: PolicyQuery,
    private policiesService: PolicyService,
  ) {
    this.policy = this.policyQuery.getActive();
  }

  ngOnInit(): void {

  }
  cancelConfirmed(): void{
    this.policiesService.cancelPolicy(this.policy.policy_id,this.item.session_item_id,this.item.class_id,0);
    jQuery("#cancel-confirm-modal").modal('show');
  }
}
